import React, { FC } from "react";
import Heading from "components/Heading/Heading";
// import Pagination from "shared/Pagination/Pagination";
// import ButtonPrimary from "shared/Button/ButtonPrimary";
// import WidgetTags from "./WidgetTags";
// import WidgetCategories from "./WidgetCategories";
import WidgetPosts from "./WidgetPosts";
import Card3 from "./Card3";
import { IBlog } from "types/blog";

// THIS IS DEMO FOR MAIN DEMO
// OTHER DEMO WILL PASS PROPS
//
export interface SectionLatestPostsProps {
  blogs?: IBlog[];
  className?: string;
  postCardName?: "card3";
}

const SectionLatestPosts: FC<SectionLatestPostsProps> = ({
  blogs = [],
  postCardName = "card3",
  className = "",
}) => {
  const filteredBlog =
    blogs.length > 0
      ? blogs.filter((b) => b.status === "published").reverse()
      : [];

  const renderCard = (blog: IBlog) => {
    switch (postCardName) {
      case "card3":
        return <Card3 key={blog._id} className="" blog={blog} />;

      default:
        return null;
    }
  };

  return (
    <div className={`nc-SectionLatestPosts relative ${className}`}>
      <div className="flex flex-col lg:flex-row">
        <div className="w-full lg:w-3/5 xl:w-2/3 xl:pr-14">
          <Heading>Postingan Terbaru 🎈</Heading>
          <div className={`grid gap-6 md:gap-8 grid-cols-1`}>
            {blogs.length > 0 &&
              blogs
                .filter((blog) => blog.status === "published")
                .map((blog) => renderCard(blog))
                .reverse()}
          </div>
          {/* <div className="flex flex-col mt-12 md:mt-20 space-y-5 sm:space-y-0 sm:space-x-3 sm:flex-row sm:justify-between sm:items-center">
            <Pagination />
            <ButtonPrimary>Baca lebih lanjut</ButtonPrimary>
          </div> */}
        </div>
        <div className="w-full space-y-7 mt-24 lg:mt-0 lg:w-2/5 lg:pl-10 xl:pl-0 xl:w-1/3 ">
          {/* <WidgetTags />
          <WidgetCategories /> */}
          <WidgetPosts blogs={filteredBlog} />
        </div>
      </div>
    </div>
  );
};

export default SectionLatestPosts;
